import {useState} from 'react';
import {postAuthCaptchaVerify} from 'api/auth';

function useLoginCaptcha() {
  const [isVerifying, setIsVerifying] = useState();
  const [captchaSession, setCaptchaSession] = useState();

  async function verifyCaptcha(response, type) {
    setIsVerifying(true);
    try {
      const {data} = await postAuthCaptchaVerify({
        response,
        type,
      });
      const {captcha_session_id} = data || {};

      setCaptchaSession(captcha_session_id);
      setIsVerifying(false);
    } catch (e) {
      setIsVerifying(false);
      console.log(e);
    }
  }

  return {
    isVerifying,
    verifyCaptcha,
    captchaSession,
    setCaptchaSession,
  };
}

export default useLoginCaptcha;
